import { render, staticRenderFns } from "./LayoutLoadable.vue?vue&type=template&id=2cf21391&"
import script from "./LayoutLoadable.vue?vue&type=script&lang=ts&"
export * from "./LayoutLoadable.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutLoadable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports